// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__codeMapping{
  display: grid;
  grid-template-columns: 280px 1fr;
  font-size: var(--title);
  margin-top: 5px;
  height: 100%;
  gap: 12px;
}
@media (min-height: 768px) {
  .__codeMapping{
    display: grid;
    grid-template-columns: 280px 1fr;
    font-size: 2rem;
    height: 100%;
    margin-top: 5px;
    gap: 12px;
  }
}
.__codeMapping__filters{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  background: #ffffff;
  height: fit-content;
  padding-bottom: 8px;
}
.__codeMapping__grid{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  background: #ffffff;
  height: fit-content;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
}
.__codeMapping__grid--container{
  padding-bottom: 1px;
}
.__codeMapping__grid--container-title{
  font-weight: 600;
  font-size: var(--title);
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
  margin: 0;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
@media (min-height: 768px) {
  .__codeMapping__grid--container-title {
    font-family: Segoe UI;
    font-weight: 600;
    font-size: var(--subheader);
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #000;
    margin: 0;
    padding: 10px 12px;
  }
}
.__codeMapping__grid--container-freeAcion{
  display: flex;
  align-items: flex-end;
}
.__codeMapping__grid--container-dateRange{
  margin-right: 12px;
  font-size: 16px;
}
.action-tooltip {
  top: 0.5rem;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/CodeMapping/CodeMapping.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".__codeMapping{\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  font-size: var(--title);\n  margin-top: 5px;\n  height: 100%;\n  gap: 12px;\n}\n@media (min-height: 768px) {\n  .__codeMapping{\n    display: grid;\n    grid-template-columns: 280px 1fr;\n    font-size: 2rem;\n    height: 100%;\n    margin-top: 5px;\n    gap: 12px;\n  }\n}\n.__codeMapping__filters{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  background: #ffffff;\n  height: fit-content;\n  padding-bottom: 8px;\n}\n.__codeMapping__grid{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  background: #ffffff;\n  height: fit-content;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.__codeMapping__grid--container{\n  padding-bottom: 1px;\n}\n.__codeMapping__grid--container-title{\n  font-weight: 600;\n  font-size: var(--title);\n  line-height: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #000;\n  margin: 0;\n  padding: 10px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n@media (min-height: 768px) {\n  .__codeMapping__grid--container-title {\n    font-family: Segoe UI;\n    font-weight: 600;\n    font-size: var(--subheader);\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #000;\n    margin: 0;\n    padding: 10px 12px;\n  }\n}\n.__codeMapping__grid--container-freeAcion{\n  display: flex;\n  align-items: flex-end;\n}\n.__codeMapping__grid--container-dateRange{\n  margin-right: 12px;\n  font-size: 16px;\n}\n.action-tooltip {\n  top: 0.5rem;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
